
import { CreateElement } from "vue";
export default {
  name: "App",
  components: {},
  render: (c: CreateElement) => c("router-view"),
};
